export const getUrlWithoutLastParam = (url: string) => {
  const splittedUrl = url.split('/');
  splittedUrl.pop();
  return splittedUrl.join('/');
};
